import { render } from "./NotFound.vue?vue&type=template&id=1a204053"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\mestre\\mestre-do-valor-sn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__